// src/constants/translations/filterTranslations.js

export const FILTER_TRANSLATIONS = {
    // English translations
    en: {
      // Category Names
      categories: {
        "스킨케어": "Skincare",
        "바디케어": "Body Care", 
        "헤어케어": "Hair Care",
        "선케어": "Sun Care",
        "클렌징": "Cleansing",
        "Common": "Common"
      },
  
      // Questions
      questions: {
        // Skincare Questions (CM01)
        "제품 타입": "Product Type",
        "주요 기능": "Main Function",
        "텍스처": "Texture",
        "피부 타입 적합성": "Skin Type Suitability",
        "향": "Fragrance",
  
        // Body Care Questions (CM02)
        "종류": "Type",
        "주요 효과": "Main Effects",
        "사용 부위": "Usage Area",
        "특수 기능": "Special Functions",
        "지속력": "Longevity",
        "천연 성분 비율": "Natural Ingredient Ratio",
  
        // Hair Care Questions (CM03)
        "모발 타입 적합성": "Hair Type Suitability",
        "향의 지속력": "Fragrance Longevity",
        "실리콘 포함 여부": "Silicone Content",
  
        // Sun Care Questions (CM04)
        "타입": "Type",
        "SPF 지수": "SPF Level",
        "PA 등급": "PA Grade",
        "백탁 현상": "White Cast",
        "메이크업 베이스 겸용 가능": "Makeup Base Compatible",
        "부가 기능": "Additional Functions",
        "사용 목적": "Usage Purpose",
        "특별 기능": "Special Features",
  
        // Cleansing Questions (CM05)
        "제형": "Formulation",
        "강도": "Strength",
        "주요 클렌징 대상": "Main Cleansing Target",
        "pH 레벨": "pH Level",
        "특별 성분 포함": "Special Ingredients",
        "헹굼 여부": "Rinse Required",
        "주요 특징": "Main Features",
  
        // Common Questions (CM00)
        "친환경 패키징 사용": "Eco-friendly Packaging",
        "지속가능한 원료 사용": "Sustainable Ingredients",
        "환경 보호 캠페인 참여": "Environmental Campaign Participation",
        "제품 구성": "Product Composition",
        "주요 성분": "Main Ingredients",
        "핵심 기술": "Core Technology",
        "비건 여부": "Vegan Status",
        "주요 인증 그룹": "Main Certification Group",
  
        // Common Questions (CM99)
        "제품 컬러": "Product Color",
        "제품 유형": "Product Type"
      },
  
      // Options
      options: {
        // SKINCARE OPTIONS (CM01)
        "토너": "Toner",
        "에센스": "Essence",
        "세럼": "Serum",
        "미스트": "Mist",
        "앰플": "Ampoule",
        "크림": "Cream",
        "에멀전": "Emulsion",
        "로션": "Lotion",
        "아이크림": "Eye Cream",
        "수분크림": "Moisturizer",
        "재생크림": "Regenerating Cream",
  
        "보습": "Moisturizing",
        "진정": "Soothing",
        "미백": "Whitening",
        "각질제거": "Exfoliating",
        "안티에이징": "Anti-aging",
        "주름개선": "Wrinkle Improvement",
        "모공관리": "Pore Care",
        "피지조절": "Sebum Control",
        "재생": "Regenerating",
  
        "가벼운": "Lightweight",
        "무거운": "Heavy",
        "쫀쫀한": "Bouncy",
        "촉촉한": "Moist",
        "매트한": "Matte",
        "부드러운": "Soft",
  
        "지성": "Oily",
        "건성": "Dry",
        "복합성": "Combination",
        "모든 피부": "All Skin Types",
        "수분부족형 지성": "Dehydrated Oily",
  
        "플로랄": "Floral",
        "프루티": "Fruity",
        "시트러스": "Citrus",
        "프레쉬": "Fresh",
        "그린": "Green",
        "우디": "Woody",
        "오리엔탈": "Oriental",
        "스파이시": "Spicy",
        "고메": "Gourmand",
        "레더": "Leather",
        "파우더": "Powder",
        "코튼": "Cotton",
        "무향": "Fragrance-free",
  
        // BODY CARE OPTIONS (CM02)
        "제모제": "Hair Removal",
        "데오드란트": "Deodorant",
        "바디오일": "Body Oil",
        "바디미스트": "Body Mist",
        "샤워젤/바디워시": "Shower Gel/Body Wash",
        "바디로션/크림": "Body Lotion/Cream",
        "핸드/풋 케어": "Hand/Foot Care",
        "바디 트리트먼트 마스크/패치": "Body Treatment Mask/Patch",
  
        "피부결 개선": "Skin Texture Improvement",
        "탄력 개선": "Elasticity Improvement",
        "향기": "Fragrance",
        "미백/브라이트닝": "Whitening/Brightening",
        "트러블 케어": "Trouble Care",
        "모발 제거": "Hair Removal",
  
        "전신": "Full Body",
        "얼굴": "Face",
        "손/발": "Hands/Feet",
        "특정 바디 부위 (등, 가슴 등)": "Specific Body Parts (Back, Chest, etc.)",
  
        "머스크": "Musk",
        "허브/그린": "Herb/Green",
  
        "크리미한": "Creamy",
        "리치한": "Rich",
  
        "임산부 안전": "Pregnancy Safe",
        "각질 제거": "Exfoliation",
        "셀룰라이트 관리": "Cellulite Care",
        "저자극/민감성 피부용": "Low Irritation/Sensitive Skin",
  
        "모든 피부 타입": "All Skin Types",
        "민감성": "Sensitive",
  
        "지속력에 대한 언급 없음": "No Mention of Longevity",
        "보통의 지속력": "Average Longevity",
        "오랜 지속력": "Long-lasting",
  
        "100% 천연/유기농": "100% Natural/Organic",
        "70% 이상": "70% or more",
        "50% 이상": "50% or more",
        "30% 이상": "30% or more",
        "해당 없음/명시되지 않음": "Not Applicable/Not Specified",
  
        // HAIR CARE OPTIONS (CM03)
        "샴푸": "Shampoo",
        "린스": "Rinse",
        "트리트먼트": "Treatment",
        "헤어 에센스": "Hair Essence",
        "스타일링 제품": "Styling Product",
        "헤어 케어 도구": "Hair Care Tools",
  
        "건조모": "Dry Hair",
        "지성모": "Oily Hair",
        "손상모": "Damaged Hair",
        "염색모": "Color-treated Hair",
        "민감성 두피": "Sensitive Scalp",
        "모든 모발 타입": "All Hair Types",
  
        "두피 케어": "Scalp Care",
        "볼륨": "Volume",
        "컬 유지": "Curl Maintenance",
        "윤기 부여": "Shine Enhancement",
        "탈모 예방": "Hair Loss Prevention",
        "손상 복구": "Damage Repair",
        "열 보호": "Heat Protection",
  
        "약함": "Weak",
        "보통": "Average",
        "강함": "Strong",
        "오래 지속": "Long-lasting",
  
        "실리콘 포함": "Contains Silicone",
        "실리콘 프리": "Silicone-free",
  
        "100%": "100%",
  
        // SUN CARE OPTIONS (CM04)
        "선크림": "Sunscreen",
        "선스틱": "Sun Stick",
        "선쿠션": "Sun Cushion",
        "선스프레이": "Sun Spray",
        "선패치": "Sun Patch",
        "에프터선 케어": "After Sun Care",
  
        "SPF15-30": "SPF15-30",
        "SPF30-50": "SPF30-50",
        "SPF50+": "SPF50+",
  
        "PA+": "PA+",
        "PA++": "PA++",
        "PA+++": "PA+++",
        "PA++++": "PA++++",
  
        "있음": "Present",
        "약간 있음": "Slightly Present",
        "없음": "None",
  
        "얼굴용": "For Face",
        "바디용": "For Body",
        "얼굴/바디 겸용": "Face/Body Dual Use",
  
        "가능": "Compatible",
        "불가능": "Not Compatible",
  
        "톤업": "Tone Up",
        "수분 공급": "Hydration",
        "쿨링": "Cooling",
        "피부 보호": "Skin Protection",
  
        "일상적 자외선 차단": "Daily UV Protection",
        "스포츠/아웃도어 활동": "Sports/Outdoor Activities",
        "피부 진정": "Skin Soothing",
  
        "워터프루프": "Waterproof",
        "쿨링 효과": "Cooling Effect",
        "땀에 강함": "Sweat Resistant",
        "밀착력": "Adhesion",
  
        // CLEANSING OPTIONS (CM05)
        "폼": "Foam",
        "젤": "Gel",
        "오일": "Oil",
        "밀크": "Milk",
        "클렌징파우더": "Cleansing Powder",
        "밤": "Balm",
        "워터": "Water",
        "티슈": "Tissue",
  
        "메이크업": "Makeup",
        "블랙헤드": "Blackheads",
        "피지": "Sebum",
        "미세먼지": "Fine Dust",
  
        "약산성": "Mildly Acidic",
        "중성": "Neutral",
        "약알칼리성": "Mildly Alkaline",
  
        "미네랄": "Mineral",
        "AHA/BHA": "AHA/BHA",
        "비타민": "Vitamin",
        "식물 추출물": "Plant Extract",
        "자체 개발 성분": "Proprietary Ingredient",
  
        "헹굼 필요": "Rinse Required",
        "헹굼 불필요": "No Rinse Required",
  
        "딥 클렌징": "Deep Cleansing",
        "저자극": "Low Irritation",
        "미세먼지 제거": "Fine Dust Removal",
  
        // COMMON OPTIONS (CM00)
        "재활용 가능 패키징": "Recyclable Packaging",
        "생분해성 패키징": "Biodegradable Packaging",
        "리필제품 제공": "Refill Available",
        "포장 간소화": "Simplified Packaging",
  
        "해당 없음": "Not Applicable",
        "유기농 원료 사용": "Organic Ingredients",
        "공정무역 원료 사용": "Fair Trade Ingredients",
        "지속가능한 방식으로 재배된 원료 사용": "Sustainably Grown Ingredients",
  
        "탄소중립 프로그램 참여": "Carbon Neutral Program",
        "해양 보호 활동 지원": "Ocean Protection Support",
        "산림 보호 활동 지원": "Forest Protection Support",
        "기타 환경 보호 활동 참여": "Other Environmental Activities",
  
        "시리즈": "Series",
        "콤보": "Combo",
        "라인": "Line",
  
        "비건 원료 사용": "Vegan Ingredients",
  
        "품질 및 안전": "Quality & Safety",
        "피부과학 및 저자극": "Dermatological & Hypoallergenic",
        "국가별 규제 준수": "Regulatory Compliance",
        "환경 및 지속가능성": "Environmental & Sustainability",
        "윤리적 및 동물실험 반대": "Ethical & Cruelty-free",
        "유기농 및 천연": "Organic & Natural",
  
        // COMMON OPTIONS (CM99)
        "빨강": "Red",
        "파랑": "Blue",
        "초록": "Green",
        "노랑": "Yellow",
        "보라": "Purple",
        "주황": "Orange",
        "분홍": "Pink",
        "갈색": "Brown",
        "회색": "Gray",
        "검정": "Black",
        "흰색": "White",
        "청록": "Cyan",
        "자홍": "Magenta",
        "라임": "Lime",
        "틸": "Teal",
        "네이비": "Navy",
        "적갈색": "Maroon",
        "올리브": "Olive",
        "은색": "Silver",
        "금색": "Gold",
        "아이보리": "Ivory",
  
        "튜브형": "Tube Type",
        "기타": "Others"
      }
    },
  
    // Vietnamese translations
    vi: {
      // Category Names
      categories: {
        "스킨케어": "Chăm sóc da",
        "바디케어": "Chăm sóc cơ thể", 
        "헤어케어": "Chăm sóc tóc",
        "선케어": "Chống nắng",
        "클렌징": "Làm sạch",
        "Common": "Chung"
      },
  
      // Questions
      questions: {
        // Skincare Questions (CM01)
        "제품 타입": "Loại sản phẩm",
        "주요 기능": "Chức năng chính",
        "텍스처": "Kết cấu",
        "피부 타입 적합성": "Phù hợp với loại da",
        "향": "Hương thơm",
  
        // Body Care Questions (CM02)
        "종류": "Loại",
        "주요 효과": "Tác dụng chính",
        "사용 부위": "Vùng sử dụng",
        "특수 기능": "Chức năng đặc biệt",
        "지속력": "Độ bền",
        "천연 성분 비율": "Tỷ lệ thành phần tự nhiên",
  
        // Hair Care Questions (CM03)
        "모발 타입 적합성": "Phù hợp với loại tóc",
        "향의 지속력": "Độ bền hương thơm",
        "실리콘 포함 여부": "Chứa silicone",
  
        // Sun Care Questions (CM04)
        "타입": "Loại",
        "SPF 지수": "Chỉ số SPF",
        "PA 등급": "Cấp độ PA",
        "백탁 현상": "Hiện tượng trắng bệt",
        "메이크업 베이스 겸용 가능": "Có thể dùng làm lót trang điểm",
        "부가 기능": "Chức năng bổ sung",
        "사용 목적": "Mục đích sử dụng",
        "특별 기능": "Tính năng đặc biệt",
  
        // Cleansing Questions (CM05)
        "제형": "Dạng sản phẩm",
        "강도": "Cường độ",
        "주요 클렌징 대상": "Đối tượng làm sạch chính",
        "pH 레벨": "Độ pH",
        "특별 성분 포함": "Chứa thành phần đặc biệt",
        "헹굼 여부": "Cần rửa lại",
        "주요 특징": "Đặc điểm chính",
  
        // Common Questions (CM00)
        "친환경 패키징 사용": "Sử dụng bao bì thân thiện môi trường",
        "지속가능한 원료 사용": "Sử dụng nguyên liệu bền vững",
        "환경 보호 캠페인 참여": "Tham gia chiến dịch bảo vệ môi trường",
        "제품 구성": "Cấu thành sản phẩm",
        "주요 성분": "Thành phần chính",
        "핵심 기술": "Công nghệ cốt lõi",
        "비건 여부": "Thuần chay",
        "주요 인증 그룹": "Nhóm chứng nhận chính",
  
        // Common Questions (CM99)
        "제품 컬러": "Màu sản phẩm",
        "제품 유형": "Kiểu sản phẩm"
      },
  
      // Options
      options: {
        // SKINCARE OPTIONS (CM01)
        "토너": "Toner",
        "에센스": "Tinh chất",
        "세럼": "Serum",
        "미스트": "Xịt khoáng",
        "앰플": "Ampoule",
        "크림": "Kem",
        "에멀전": "Sữa dưỡng",
        "로션": "Lotion",
        "아이크림": "Kem mắt",
        "수분크림": "Kem dưỡng ẩm",
        "재생크림": "Kem tái tạo",
  
        "보습": "Dưỡng ẩm",
        "진정": "Làm dịu",
        "미백": "Làm trắng",
        "각질제거": "Tẩy tế bào chết",
        "안티에이징": "Chống lão hóa",
        "주름개선": "Cải thiện nếp nhăn",
        "모공관리": "Chăm sóc lỗ chân lông",
        "피지조절": "Kiểm soát dầu",
        "재생": "Tái tạo",
  
        "가벼운": "Nhẹ",
        "무거운": "Nặng",
        "쫀쫀한": "Đàn hồi",
        "촉촉한": "Ẩm mượt",
        "매트한": "Mờ",
        "부드러운": "Mềm mại",
  
        "지성": "Da dầu",
        "건성": "Da khô",
        "복합성": "Da hỗn hợp",
        "모든 피부": "Mọi loại da",
        "수분부족형 지성": "Da dầu thiếu nước",
  
        "플로랄": "Hoa cỏ",
        "프루티": "Trái cây",
        "시트러스": "Cam chanh",
        "프레쉬": "Tươi mát",
        "그린": "Xanh lá",
        "우디": "Gỗ",
        "오리엔탈": "Phương Đông",
        "스파이시": "Cay nồng",
        "고메": "Ngọt ngào",
        "레더": "Da thuộc",
        "파우더": "Phấn",
        "코튼": "Cotton",
        "무향": "Không mùi",
  
        // BODY CARE OPTIONS (CM02)
        "제모제": "Tẩy lông",
        "데오드란트": "Khử mùi",
        "바디오일": "Dầu dưỡng thể",
        "바디미스트": "Xịt thơm cơ thể",
        "샤워젤/바디워시": "Gel tắm",
        "바디로션/크림": "Kem/Sữa dưỡng thể",
        "핸드/풋 케어": "Chăm sóc tay/chân",
        "바디 트리트먼트 마스크/패치": "Mặt nạ/Miếng dán điều trị cơ thể",
  
        "피부결 개선": "Cải thiện kết cấu da",
        "탄력 개선": "Tăng cường đàn hồi",
        "향기": "Hương thơm",
        "미백/브라이트닝": "Làm trắng/Làm sáng",
        "트러블 케어": "Chăm sóc mụn",
        "모발 제거": "Loại bỏ lông",
  
        "전신": "Toàn thân",
        "얼굴": "Mặt",
        "손/발": "Tay/chân",
        "특정 바디 부위 (등, 가슴 등)": "Vùng cơ thể cụ thể (lưng, ngực, v.v.)",
  
        "머스크": "Xạ hương",
        "허브/그린": "Thảo mộc/Xanh lá",
  
        "크리미한": "Kem mịn",
        "리치한": "Đậm đà",
  
        "임산부 안전": "An toàn cho bà bầu",
        "각질 제거": "Tẩy tế bào chết",
        "셀룰라이트 관리": "Chăm sóc cellulite",
        "저자극/민감성 피부용": "Ít kích ứng/Cho da nhạy cảm",
  
        "모든 피부 타입": "Mọi loại da",
        "민감성": "Nhạy cảm",
  
        "지속력에 대한 언급 없음": "Không đề cập về độ bền",
        "보통의 지속력": "Độ bền trung bình",
        "오랜 지속력": "Bền lâu",
  
        "100% 천연/유기농": "100% tự nhiên/hữu cơ",
        "70% 이상": "70% trở lên",
        "50% 이상": "50% trở lên",
        "30% 이상": "30% trở lên",
        "해당 없음/명시되지 않음": "Không áp dụng/Không ghi rõ",
  
        // HAIR CARE OPTIONS (CM03)
        "샴푸": "Dầu gội",
        "린스": "Dầu xả",
        "트리트먼트": "Kem ủ tóc",
        "헤어 에센스": "Tinh chất tóc",
        "스타일링 제품": "Sản phẩm tạo kiểu",
        "헤어 케어 도구": "Dụng cụ chăm sóc tóc",
  
        "건조모": "Tóc khô",
        "지성모": "Tóc dầu",
        "손상모": "Tóc hư tổn",
        "염색모": "Tóc nhuộm",
        "민감성 두피": "Da đầu nhạy cảm",
        "모든 모발 타입": "Mọi loại tóc",
  
        "두피 케어": "Chăm sóc da đầu",
        "볼륨": "Tạo phồng",
        "컬 유지": "Giữ nếp xoăn",
        "윤기 부여": "Tăng độ bóng",
        "탈모 예방": "Ngăn rụng tóc",
        "손상 복구": "Phục hồi tóc hư tổn",
        "열 보호": "Bảo vệ khỏi nhiệt",
  
        "약함": "Yếu",
        "보통": "Trung bình",
        "강함": "Mạnh",
        "오래 지속": "Lâu phai",
  
        "실리콘 포함": "Có chứa silicone",
        "실리콘 프리": "Không chứa silicone",
  
        "100%": "100%",
  
        // SUN CARE OPTIONS (CM04)
        "선크림": "Kem chống nắng",
        "선스틱": "Thỏi chống nắng",
        "선쿠션": "Cushion chống nắng",
        "선스프레이": "Xịt chống nắng",
        "선패치": "Miếng dán chống nắng",
        "에프터선 케어": "Chăm sóc sau phơi nắng",
  
        "SPF15-30": "SPF15-30",
        "SPF30-50": "SPF30-50",
        "SPF50+": "SPF50+",
  
        "PA+": "PA+",
        "PA++": "PA++",
        "PA+++": "PA+++",
        "PA++++": "PA++++",
  
        "있음": "Có",
        "약간 있음": "Có một chút",
        "없음": "Không",
  
        "얼굴용": "Cho mặt",
        "바디용": "Cho cơ thể",
        "얼굴/바디 겸용": "Dùng chung mặt/cơ thể",
  
        "가능": "Được",
        "불가능": "Không được",
  
        "톤업": "Nâng tone",
        "수분 공급": "Cấp ẩm",
        "쿨링": "Làm mát",
        "피부 보호": "Bảo vệ da",
  
        "일상적 자외선 차단": "Chống tia UV hàng ngày",
        "스포츠/아웃도어 활동": "Hoạt động thể thao/ngoài trời",
        "피부 진정": "Làm dịu da",
  
        "워터프루프": "Chống nước",
        "쿨링 효과": "Hiệu ứng làm mát",
        "땀에 강함": "Chống mồ hôi",
        "밀착력": "Độ bám",
  
        // CLEANSING OPTIONS (CM05)
        "폼": "Bọt",
        "젤": "Gel",
        "오일": "Dầu",
        "밀크": "Sữa",
        "클렌징파우더": "Bột rửa mặt",
        "밤": "Balm",
        "워터": "Nước",
        "티슈": "Khăn ướt",
  
        "메이크업": "Trang điểm",
        "블랙헤드": "Mụn đầu đen",
        "피지": "Dầu nhờn",
        "미세먼지": "Bụi mịn",
  
        "약산성": "Axit nhẹ",
        "중성": "Trung tính",
        "약알칼리성": "Kiềm nhẹ",
  
        "미네랄": "Khoáng chất",
        "AHA/BHA": "AHA/BHA",
        "비타민": "Vitamin",
        "식물 추출물": "Chiết xuất thực vật",
        "자체 개발 성분": "Thành phần tự phát triển",
  
        "헹굼 필요": "Cần rửa lại",
        "헹굼 불필요": "Không cần rửa lại",
  
        "딥 클렌징": "Làm sạch sâu",
        "저자극": "Ít kích ứng",
        "미세먼지 제거": "Loại bỏ bụi mịn",
  
        // COMMON OPTIONS (CM00)
        "재활용 가능 패키징": "Bao bì có thể tái chế",
        "생분해성 패키징": "Bao bì phân hủy sinh học",
        "리필제품 제공": "Có sản phẩm refill",
        "포장 간소화": "Bao bì đơn giản",
  
        "해당 없음": "Không áp dụng",
        "유기농 원료 사용": "Sử dụng nguyên liệu hữu cơ",
        "공정무역 원료 사용": "Sử dụng nguyên liệu thương mại công bằng",
        "지속가능한 방식으로 재배된 원료 사용": "Sử dụng nguyên liệu trồng bền vững",
  
        "탄소중립 프로그램 참여": "Tham gia chương trình carbon trung tính",
        "해양 보호 활동 지원": "Hỗ trợ hoạt động bảo vệ đại dương",
        "산림 보호 활동 지원": "Hỗ trợ hoạt động bảo vệ rừng",
        "기타 환경 보호 활동 참여": "Tham gia các hoạt động bảo vệ môi trường khác",
  
        "시리즈": "Series",
        "콤보": "Combo",
        "라인": "Dòng sản phẩm",
  
        "비건 원료 사용": "Sử dụng nguyên liệu thuần chay",
  
        "품질 및 안전": "Chất lượng & An toàn",
        "피부과학 및 저자극": "Da liệu học & Ít kích ứng",
        "국가별 규제 준수": "Tuân thủ quy định các nước",
        "환경 및 지속가능성": "Môi trường & Bền vững",
        "윤리적 및 동물실험 반대": "Đạo đức & Không thử nghiệm trên động vật",
        "유기농 및 천연": "Hữu cơ & Tự nhiên",
  
        // COMMON OPTIONS (CM99)
        "빨강": "Đỏ",
        "파랑": "Xanh dương",
        "초록": "Xanh lá",
        "노랑": "Vàng",
        "보라": "Tím",
        "주황": "Cam",
        "분홍": "Hồng",
        "갈색": "Nâu",
        "회색": "Xám",
        "검정": "Đen",
        "흰색": "Trắng",
        "청록": "Xanh lam",
        "자홍": "Đỏ tím",
        "라임": "Xanh chanh",
        "틸": "Xanh mòng két",
        "네이비": "Xanh navy",
        "적갈색": "Nâu đỏ",
        "올리브": "Xanh ô liu",
        "은색": "Bạc",
        "금색": "Vàng",
        "아이보리": "Ngà",
  
        "튜브형": "Dạng tuýp",
        "기타": "Khác"
      }
    }
  };
  
  // For backward compatibility
  export const { categories, questions, options } = FILTER_TRANSLATIONS.en;
  
  export default FILTER_TRANSLATIONS;